export default __webpack_public_path__ + "static/media/ic_notification_mail.0a524554.svg";